export const selectOptionsCommercialUse = [
  "Office",
  "Restaurant",
  "Other Food Service",
  "Automotive Service",
  "Dry Cleaner",
  "Industrial - Factory or Other",
  "Other Retail",
  "TBD",
];
